import React, { PureComponent } from 'react'

import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'
import PropTypes from 'prop-types'
import { ReactReduxContext } from 'react-redux'

import Loading from '../Loading'
import { AccountOnHoldAlert } from '../components/AccountOnHold/AccountOnHoldAlert'
import { CollectionsNavContainer } from '../components/CollectionsNav'
import { FlexOrderAlert } from '../components/Flex/FlexOrderAlert'
import { JustForYouTutorial } from '../components/JustForYouTutorial'
import { MenuPreferencesTutorial } from '../components/MenuPreferences/MenuPreferencesTutorial'
import { SubHeaderContainer } from '../components/SubHeader'
import { CapacityInfo } from './CapacityInfo'
import { CollectionHeaderWrapper } from './CollectionHeader'
import { RecipeGrid } from './RecipeGrid'

import css from './MenuRecipesPage.css'

export class MenuRecipesPage extends PureComponent {
  async componentDidMount() {
    const {
      orderId,
      params,
      storeOrderId,
      basketOrderLoaded,
      query,
      portionSizeSelectedTracking,
      numPortions,
      fetchMenuData,
      addRecipe,
    } = this.props
    // if server rendered
    if (orderId && orderId === storeOrderId) {
      basketOrderLoaded(orderId)
    }
    const forceDataLoad = (storeOrderId && storeOrderId !== orderId) || query.reload
    // TODO: Add back logic to check what needs to be reloaded
    if (forceDataLoad) {
      await fetchMenuData({ query, params }, forceDataLoad, undefined, { addRecipe })
    }
    if (orderId) {
      portionSizeSelectedTracking(numPortions, orderId)
    }
  }

  componentDidUpdate(prevProps) {
    const { orderId, query, params, fetchMenuData, addRecipe } = this.props

    // /menu-> /menu/:orderId
    const editingOrder = (prevProps.orderId || orderId) && prevProps.orderId !== orderId
    if (editingOrder) {
      fetchMenuData({ query, params }, true, undefined, { addRecipe })
    }
  }

  getModals = () => {
    const { isLoading, showMenuPreferencesTutorial } = this.props

    return (
      <>
        {!isLoading && showMenuPreferencesTutorial && <MenuPreferencesTutorial />}
        {!isLoading && <JustForYouTutorial />}
      </>
    )
  }

  getPageHeader = () => {
    const { userStatus, isFlexOrder } = this.props

    const CustomBox = withCitrusTheme(Box, () => ({
      marginTop: '43px',
      marginBottom: '-32px',
    }))

    if (userStatus === 'onhold') {
      return (
        <CustomBox>
          <AccountOnHoldAlert />
        </CustomBox>
      )
    }

    if (isFlexOrder) {
      return (
        <CustomBox>
          <FlexOrderAlert />
        </CustomBox>
      )
    }

    return <CollectionHeaderWrapper />
  }

  getMenuRecipeListContent = () => {
    const {
      menuIsLoaded,
      menuLoadingErrorMessage,
      query,
      isDoubleDeckerFeatureOn,
      menuCurrentCollectionId,
      menuPreferences,
    } = this.props
    const showError = !!menuLoadingErrorMessage && !menuIsLoaded

    return (
      <div>
        {!isDoubleDeckerFeatureOn && <SubHeaderContainer />}

        <CollectionsNavContainer />

        {this.getPageHeader()}

        {menuIsLoaded && (
          <>
            <RecipeGrid
              query={query}
              doubleDeckerExperimentEnabled={isDoubleDeckerFeatureOn}
              menuCurrentCollectionId={menuCurrentCollectionId}
              menuPreferences={menuPreferences}
            />
          </>
        )}

        {showError ? (
          <h2 className={css.menuLoadingErrorMessage}>{menuLoadingErrorMessage}</h2>
        ) : null}

        {this.getModals()}
      </div>
    )
  }

  render() {
    const { showLoading, shouldShowCapacityInfo, userId } = this.props

    if (showLoading) {
      return (
        <div data-testid="menuRecipes">
          <Loading loading />
        </div>
      )
    }

    if (shouldShowCapacityInfo) {
      return (
        <div data-testid="menuRecipes">
          <CapacityInfo userId={userId} />
        </div>
      )
    }

    return (
      <div data-testid="menuRecipes">
        <div className={css.willFade}>{this.getMenuRecipeListContent()}</div>
      </div>
    )
  }
}

MenuRecipesPage.propTypes = {
  showLoading: PropTypes.bool.isRequired,
  menuIsLoaded: PropTypes.bool.isRequired,
  basketOrderLoaded: PropTypes.func.isRequired,
  portionSizeSelectedTracking: PropTypes.func.isRequired,
  orderId: PropTypes.string,
  isLoading: PropTypes.bool,
  storeOrderId: PropTypes.string,
  numPortions: PropTypes.number,
  query: PropTypes.shape({
    reload: PropTypes.bool,
    collection: PropTypes.string,
  }),
  params: PropTypes.shape({}),
  userId: PropTypes.string,
  shouldShowCapacityInfo: PropTypes.bool,
  menuLoadingErrorMessage: PropTypes.string,
  fetchMenuData: PropTypes.func.isRequired,
  addRecipe: PropTypes.func.isRequired,
  isDoubleDeckerFeatureOn: PropTypes.bool,
  menuCurrentCollectionId: PropTypes.string,
  menuPreferences: PropTypes.shape({
    display_preferences: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        selected: PropTypes.bool.isRequired,
      }),
    ),
  }),
  showMenuPreferencesTutorial: PropTypes.bool,
  userStatus: PropTypes.string,
  isFlexOrder: PropTypes.bool,
}

MenuRecipesPage.defaultProps = {
  orderId: null,
  isLoading: false,
  storeOrderId: '',
  numPortions: 2,
  query: {},
  params: {},
  userId: '',
  shouldShowCapacityInfo: false,
  menuLoadingErrorMessage: '',
  isDoubleDeckerFeatureOn: false,
  menuCurrentCollectionId: '',
  menuPreferences: null,
  showMenuPreferencesTutorial: false,
  userStatus: '',
  isFlexOrder: false,
}
MenuRecipesPage.contextType = ReactReduxContext
